import * as React from 'react';
import { FontIcon, Label } from 'office-ui-fabric-react';
import { AppExplainedLabelProps } from './AppExplainedLabel.props';
import { getComponentRootContainerProperties, iconStyle } from './AppExplainedLabel.styles';
import { AddTooltipToElement } from '../Tooltip/AddTooltipToElement';

const getTooltipHostChildElement = (iconName: string): JSX.Element => {
  return (
    <div>
      <FontIcon iconName={iconName} style={iconStyle} />
    </div>
  );
};

// A label that contains an icon and and explanation tooltip that is shown when hovering over the icon.
export const AppExplainedLabel: React.FunctionComponent<AppExplainedLabelProps> = (props: AppExplainedLabelProps): JSX.Element => {
  const { label, labelStyles, explanation, iconName } = props;

  return (
    <div style={getComponentRootContainerProperties()}>
      {AddTooltipToElement(getTooltipHostChildElement(iconName), explanation)}
      <Label styles={labelStyles}>{label}</Label>
    </div>
  );
}